import { NewsItem } from '@/helper/Types'
import { api, FetchResponse } from '@/services/ApiService'

class NewsApi {
  async fetchNews(): Promise<NewsItem[]> {
    try {
      const res = (await api.doGet('news')) as FetchResponse<NewsItem[]>
      return res.status == 204 ? [] : res.data
    } catch (e) {
      window.console.error('Error fetching news via API:')
      throw Error((e as Error).message)
    }
  }

  async fetchNewsByBrandAndCountry(brand: string, country: string): Promise<NewsItem[]> {
    try {
      const res = await api.doGet<NewsItem[]>(`admin/news/${brand}/${country}`)
      return res.status == 204 ? [] : res.data
    } catch (e) {
      window.console.error('Error fetching news via API:')
      throw Error((e as Error).message)
    }
  }

  async createNews(news: NewsItem) {
    try {
      const res = await api.doPost<NewsItem>(`admin/news/${news.brand}/${news.country}`, news)
      return res.data
    } catch (e) {
      window.console.error('Error creating news via API:')
      throw Error((e as Error).message)
    }
  }

  async updateNews(news: NewsItem) {
    try {
      const res = await api.doPost<NewsItem>(`admin/news/${news.id}`, news, 'PUT')
      return res.data
    } catch (e) {
      window.console.error('Error updating news via API:')
      throw Error((e as Error).message)
    }
  }

  async deleteNews(id: string) {
    try {
      await api.doDelete(`admin/news/${id}`)
    } catch (e) {
      window.console.error('Error deleting news via API:')
      throw Error((e as Error).message)
    }
  }
}

const newsApi = new NewsApi()
export default newsApi
